export var TaskTypeStatus;
(function (TaskTypeStatus) {
    TaskTypeStatus[TaskTypeStatus["NEW"] = 0] = "NEW";
    TaskTypeStatus[TaskTypeStatus["INWORK"] = 1] = "INWORK";
    TaskTypeStatus[TaskTypeStatus["COMPLETED"] = 2] = "COMPLETED";
    TaskTypeStatus[TaskTypeStatus["CANCELLED"] = 3] = "CANCELLED";
    TaskTypeStatus[TaskTypeStatus["ACCEPTED"] = 4] = "ACCEPTED";
    TaskTypeStatus[TaskTypeStatus["REJECT"] = -1] = "REJECT";
})(TaskTypeStatus || (TaskTypeStatus = {}));
/** Максимальна довжина тексту одного варіанта відповіді. */
export const TASK_ANSWER_TEXT_MAX_LENGTH = 255;
